import { useEffect } from 'react'
import { BrowserRouter, Route, Routes, useLocation, useNavigationType } from 'react-router-dom'

import Home from '../pages/Home'
import MalaysiaDestination from '../components/MalaysiaDestination.jsx'
import SouthKoreaDestination from '../components/SouthKoreaDestination.jsx'
import ChinaDestination from '../components/ChinaDestination.jsx'
import EuropeDestination from '../components/EuropeDestination.jsx'
import JapanDestination from '../components/JapanDestination.jsx'
import AustraliaDestination from '../components/AustraliaDestination.jsx'
import UnitedKingdomDestination from '../components/UnitedKingdomDestination.jsx'

const RETURN_SECTION_KEY = 'studybuddy:return-section'

function ScrollPositionManager() {
  const location = useLocation()
  const navigationType = useNavigationType()

  useEffect(() => {
    const scrollToElement = (id) => {
      window.requestAnimationFrame(() => {
        document.getElementById(id)?.scrollIntoView({ block: 'start' })
      })
    }

    const stateTarget = location.state?.scrollTo

    if (stateTarget) {
      window.sessionStorage.removeItem(RETURN_SECTION_KEY)
      scrollToElement(stateTarget)
      return
    }

    if (location.pathname === '/' && navigationType === 'POP') {
      const returnSection = window.sessionStorage.getItem(RETURN_SECTION_KEY)

      if (returnSection) {
        window.sessionStorage.removeItem(RETURN_SECTION_KEY)
        scrollToElement(returnSection)
        return
      }
    }

    if (location.hash) {
      scrollToElement(decodeURIComponent(location.hash.slice(1)))
      return
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [location.hash, location.key, location.pathname, location.state, navigationType])

  return null
}

function R() {
  return (
    <BrowserRouter>
      <ScrollPositionManager />
      <Routes>
        <Route path="" element={<Home />}></Route>
        <Route path="/destinations/malaysia" element={<MalaysiaDestination />} />
        <Route path="/destinations/south-korea" element={<SouthKoreaDestination />} />
        <Route path="/destinations/china" element={<ChinaDestination />} />
        <Route path="/destinations/europe" element={<EuropeDestination />} />
        <Route path="/destinations/japan" element={<JapanDestination />} />
        <Route path="/destinations/australia" element={<AustraliaDestination />} />
        <Route path="/destinations/united-kingdom" element={<UnitedKingdomDestination />} />
      </Routes>
    </BrowserRouter>
  )
}

export default R
